import { render, staticRenderFns } from "./ingress-script-widget.vue?vue&type=template&id=d5aabaf8"
import script from "./ingress-script-widget.vue?vue&type=script&lang=js"
export * from "./ingress-script-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports